import { AgencyUserEntity } from '@resident-select/domain/agency-user';
import { createAction, props } from '@ngrx/store';

export const CreatedAgencyUserEvent = createAction(
  'CreatedAgencyUserEvent',
  props<{
    agencyUser: AgencyUserEntity;
  }>(),
);

export const UpdatedAgencyUserEvent = createAction(
  'UpdatedAgencyUserEvent',
  props<{
    agencyUser: AgencyUserEntity;
  }>(),
);
export const GottenAgencyUsersEvent = createAction(
  'GottenAgencyUsersEvent',
  props<{
    agencyUsers: AgencyUserEntity[];
  }>(),
);
